import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getProducers } from "../api/ProfileAPIs";

import { useNavigate } from 'react-router-dom';
import Header from "../../../layouts/Header";

function Producers() {
    const navigate = useNavigate();

    const [producers, setProducers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [search, setSearch] = useState('');
    const [cityId, setCityId] = useState(null);

    const observer = useRef();

    // وقتی فیلترها تغییر کنند، لیست را از نو بارگذاری کنید
    useEffect(() => {
        // ریست داده‌ها برای فیلترهای جدید
        setProducers([]);
        setPage(1);
        setHasMore(true);
    }, [search, cityId]);

    // فراخوانی API با پارامترهای دقیق
    const fetchProducers = useCallback(async (pageToFetch) => {
        setLoading(true);
        try {
            const params = { count: 10, list: 1, page: pageToFetch };
            if (search) params.search = search;
            if (cityId) params.cityid = cityId;

            const data = await getProducers(params);

            if (pageToFetch === 1) {
                setProducers(data.data || []);
            } else {
                setProducers(prev => [...prev, ...(data.data || [])]);
            }

            setHasMore((data?.meta?.current_page ?? 0) < (data?.meta?.last_page ?? 0));

            const nextPage = (data?.meta?.current_page ?? pageToFetch) + 1;
            setPage(nextPage);
        } catch (error) {
            console.error('Failed to fetch producers:', error);
        } finally {
            setLoading(false);
        }
    }, [search, cityId]);

    // بارگذاری اولیه و با تغییر فیلترها
    useEffect(() => {
        fetchProducers(1);
    }, [fetchProducers]);

    // Infinite scroll با IntersectionObserver
    const lastProducerRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchProducers(page);
            }
        });
        if (node) observer.current.observe(node);
    }, [loading, hasMore, fetchProducers, page]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    return (
        <div className="container producer-list-container py-4 mt-5">
            <Header title="تولید کننده ها" hasBack={true} />

            <div className="input-group filter-group mb-4">
                <input
                    type="text"
                    className="form-control border-0"
                    placeholder="جستجو..."
                    value={search}
                    onChange={handleSearchChange}
                />

            </div>

            <div className="list-group">
                {producers.map((producer, index) => {
                    const isLast = producers.length === index + 1;
                    return (
                        <div
                            ref={isLast ? lastProducerRef : null}
                            key={producer.id}
                            className="list-group-item producer-item d-flex align-items-center justify-content-between p-3 mb-3"
                            onClick={() => navigate(`/producer/${producer.id}`)}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src={producer.image}
                                    alt={producer.name}
                                    className="producer-image ms-3"
                                    height={50}
                                    width={50}
                                />
                                <div>
                                    <h6 className="mb-0 fw-bold">{producer.name}</h6>
                                    {producer.brief && (
                                        <p className="text-small-3 text-muted mb-0 mt-2 px-3">
                                            {producer.brief}
                                        </p>
                                    )}
                                </div>
                            </div>
                            {producer.city && (
                                <div>
                                    <span className="city-tag badge">{producer.city.name}</span>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {loading && (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">در حال بارگذاری...</span>
                    </div>
                </div>
            )}

            {!loading && producers.length === 0 && (
                <p className="text-center text-muted mt-5">تامین‌کننده‌ای یافت نشد.</p>
            )}
        </div>
    );
}

export default Producers;
